import React, { createContext, useContext, useState, useCallback } from 'react';

const TaskbarContext = createContext(null);

export function TaskbarProvider({ children }) {
  const [items, setItems] = useState([]);
  const [pendingRestore, setPendingRestore] = useState(null);

  const [recentItems, setRecentItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('qg_tb_recent') || '[]'); }
    catch { return []; }
  });

  const addItem = useCallback((item) => {
    setItems(prev => {
      if (prev.find(i => i.id === item.id)) return prev;
      if (prev.length >= 10) return prev;
      return [...prev, item];
    });
    setRecentItems(prev => {
      const filtered = prev.filter(i => i.id !== item.id);
      const next = [{ ...item, openedAt: Date.now() }, ...filtered].slice(0, 20);
      try { localStorage.setItem('qg_tb_recent', JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  const removeItem = useCallback((id) => {
    setItems(prev => prev.filter(i => i.id !== id));
  }, []);

  const restoreItem = useCallback((id) => {
    setItems(prev => {
      const item = prev.find(i => i.id === id);
      if (item) {
        setTimeout(() => setPendingRestore(item), 0);
      }
      return prev.filter(i => i.id !== id);
    });
  }, []);

  const clearPendingRestore = useCallback(() => setPendingRestore(null), []);

  const clearRecentItems = useCallback(() => {
    setRecentItems([]);
    try { localStorage.removeItem('qg_tb_recent'); } catch {}
  }, []);

  const addToRecent = useCallback((item) => {
    setRecentItems(prev => {
      const filtered = prev.filter(i => i.id !== item.id);
      const next = [{ ...item, openedAt: Date.now() }, ...filtered].slice(0, 20);
      try { localStorage.setItem('qg_tb_recent', JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  return (
    <TaskbarContext.Provider value={{
      items,
      recentItems,
      pendingRestore,
      addItem,
      removeItem,
      restoreItem,
      clearPendingRestore,
      clearRecentItems,
      addToRecent,
    }}>
      {children}
    </TaskbarContext.Provider>
  );
}

export function useTaskbar() {
  const ctx = useContext(TaskbarContext);
  if (!ctx) return {
    items: [],
    recentItems: [],
    pendingRestore: null,
    addItem: () => {},
    removeItem: () => {},
    restoreItem: () => {},
    clearPendingRestore: () => {},
    clearRecentItems: () => {},
    addToRecent: () => {},
  };
  return ctx;
}
